import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import MdKeyboardArrowLeft from 'react-icons/lib/md/keyboard-arrow-left';

import * as types from '../../../routes/types';
import Button from '../../ui/Button';

import title from '../../../reducers/app/title';

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 32,
  marginBottom: 32,
});

class EventFooter extends React.PureComponent {
  static propTypes = {
    locationPrev: PropTypes.shape({
      type: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired,
      payload: PropTypes.object.isRequired,
    }),
  };

  get backLabel() {
    const { type } = this.props.locationPrev;

    const prevTitle = title('', this.props.locationPrev);

    if (!type) {
      return 'Back to Events';
    }

    switch (this.props.locationPrev.type) {
      case types.ROUTE_HOME:
        return 'Back to Home';
      case types.ROUTE_SEARCH_QUERY_TEXT:
        return 'Back to Search Results';
      default:
        return `Back to ${prevTitle}`;
    }
  }

  get navTo() {
    const { pathname } = this.props.locationPrev;

    return pathname ? pathname : '/events';
  }

  render() {
    return (
      <Row>
        <Button
          color="primary"
          label={this.backLabel}
          navTo={this.navTo}
          leftIcon={<MdKeyboardArrowLeft size={24} />}
        />
      </Row>
    );
  }
}

export default EventFooter;



// WEBPACK FOOTER //
// ./src/components/features/Event/EventFooter.js